import "./Author.css";
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Skeleton from "../../components/Skeleton";
import { Helmet } from "react-helmet-async";

const Author = ({ dark, MyBaseUrl }) => {
  const [authors, setAuthors] = useState([]);
  const [loading, setLoading] = useState(true);

  const CACHE_KEY = "authors_list";

  useEffect(() => {
    const cached = localStorage.getItem(CACHE_KEY);

    if (cached) {
      setAuthors(JSON.parse(cached));
      setLoading(false);
    }

    fetch(`${MyBaseUrl}/authors`)
      .then(res => res.json())
      .then(data => {
        const list = data?.data?.data || [];
        setAuthors(list);
        setLoading(false);

        localStorage.setItem(CACHE_KEY, JSON.stringify(list));
      })
      .catch(err => {
        console.log(err);
        setLoading(false);
      });
  }, []);

  return (
    <div className="homer">

      <Helmet>
  <title>Authors | Meet Our Sports Writers & Contributors</title>

  <meta
    name="description"
    content="Explore our list of authors and sports writers. Discover profiles, biographies, and contributions from the creators behind the latest football news, match analysis, and sports updates."
  />

  <meta
    name="keywords"
    content="sports authors, football writers, sports journalists, article authors, contributors, football news writers, sports blog authors, match analysts"
  />

  <meta
    property="og:title"
    content="Authors | Sports Writers & Contributors"
  />

  <meta
    property="og:description"
    content="Meet the authors behind our sports content. View profiles, join dates, and contributions from football writers and analysts."
  />
</Helmet>

      <div
        className="authorPage"
      >
        <h1 style={dark ? { color: "#fafafa" } : {}}>
          Authors
        </h1>

        {loading ? (
          <div className="authorGrid">
            {[...Array(6)].map((_, i) => (
              <div key={i} className="authorCard">
                <Skeleton dark={dark} count={1} />
              </div>
            ))}
          </div>
        ) : authors.length <= 0 ? (
          <p style={{ textAlign: "center", marginTop: "40px" }}>
            No authors available
          </p>
        ) : (
          <>
            <section className="firstsection">
              {authors.map((item, index) => {
                return (
                  <Link
                    to={`/authors/${item.name
                        ?.trim()
                        .toLowerCase()
                        .replace(/[^a-z0-9\s]/g, "")
                        .replace(/\s+/g, "-")
                        }`}
                    key={item.id || index}
                    className="authorCard"
                    style={dark ? { backgroundColor: "#1a1a1a" } : {}}
                  >
                    <div className="imgWrap">
                      <img
                        src={
                          item.avatar ||
                          "https://ui-avatars.com/api/?name=" + item.name
                        }
                        alt={item.name}
                      />
                    </div>

                    <div className="content">
                      <h3>
                        {item.name}
                      </h3>

                      {/* <p>
                        {item.bio}
                      </p> */}

                      <div className="meta">
                        <span>
                          Joined
                        </span>

                        <span>
                          {item?.created_at?.slice(0, 10)}
                        </span>
                      </div>
                    </div>
                  </Link>
                );
              })}
            </section>

            {/* <div className="authorGrid">
              {authors.slice(1, 12).map((item, index) => {
                return (
                  <Link
                    to={`/author/${item.id}`}
                    key={item.id || index}
                    className="authorCard"
                    style={dark ? { backgroundColor: "#1a1a1a" } : {}}
                  >
                    <div className="imgWrap">
                      <img
                        src={
                          item.avatar ||
                          "https://ui-avatars.com/api/?name=" + item.name
                        }
                        alt={item.name}
                      />
                    </div>

                    <div className="content">
                      <h3 style={dark ? { color: "#fff" } : {}}>
                        {item.name}
                      </h3>

                      <p style={dark ? { color: "#bdbdbd" } : {}}>
                        {item.bio}
                      </p>

                      <div className="meta">
                        <span>Joined</span>

                        <span>
                          {item?.created_at?.slice(0, 10)}
                        </span>
                      </div>
                    </div>
                  </Link>
                );
              })}
            </div> */}
          </>
        )}
      </div>

    </div>
  );
};

export default Author;